import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Api from '../cmp/admin/cmp/api/api';
import DOMPurify from 'dompurify';
import { Oval as Loader } from 'react-loader-spinner';
import { useLocation } from 'react-router-dom';

const EducationArticle = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const article = location.state?.article;

    if (!article) {
        return <div style={{ padding: 40 }}>Article not found.</div>;
    }

    const cleanHtml = DOMPurify.sanitize(article.body);

    return (
        <main style={{ width: "min(900px, 94%)", margin: "40px auto", color: "#333" }}>
            {/* <div style={{ marginBottom: 20 }}>
                <Link to="/education" style={{ color: "#02af90", textDecoration: "none" }}>← Back to Education</Link>
            </div> */}

            <h1 style={{ fontSize: "2rem", marginBottom: 20, lineHeight: 1.3 }}>
                {article.title}
            </h1>

            {article.images?.length > 0 && (
                <img
                    src={article.images[0]}
                    alt={article.title}
                    style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: 12,
                        objectFit: "contain",
                        marginBottom: 25,
                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
                    }}
                />
            )}

            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "25px 30px",
                    borderRadius: 10,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                    fontSize: "1.1rem",
                    lineHeight: 1.7
                }}
                dangerouslySetInnerHTML={{ __html: cleanHtml }}
            />
        </main>
    );
};

export default EducationArticle;
